import { createContext } from "react";

import { AuthenticationContextType } from "./AuthenticationContext.types";

export const AuthenticationContext = createContext<AuthenticationContextType | undefined>(
  undefined,
);
